import LegalGroup from './LegalGroup';
import Accordion from '../Accordion';

import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className={`${styles.rootFooter} hidden-xs`}>
      <Accordion className='hidden-xs' />
      <LegalGroup />
    </footer>
  );
};

export default Footer;
